module.exports = __webpack_public_path__ + "assets/apple-icon-120x120.68c0b798.png";